import type React from "react";

import BoundingBoxMesh from "./BoundingBoxMesh";
import LineHandles from "./LineHandles";
import MultiSelectionControls from "./MultiSelectionControls";
import RotateButton from "./RotateButton";
import ScaleButton from "./ScaleButton";
import {TransformPositionWithDrag} from "./drag/TransformPositionWithDrag";

const SelectionControls: React.FC = () => {
  return (
    <>
      <MultiSelectionControls />

      <TransformPositionWithDrag>
        <BoundingBoxMesh />
      </TransformPositionWithDrag>

      <RotateButton relativePosition={[0, 1]} />

      {/* Unconstrained Buttons (Corners) */}
      <ScaleButton relativePosition={[1, 1]} constrainAxis="both" />
      <ScaleButton relativePosition={[-1, 1]} constrainAxis="both" />
      <ScaleButton relativePosition={[1, -1]} constrainAxis="both" />
      <ScaleButton relativePosition={[-1, -1]} constrainAxis="both" />

      {/* Constrained Buttons (Sides) */}
      <ScaleButton relativePosition={[0, 1]} constrainAxis="y" />
      <ScaleButton relativePosition={[0, -1]} constrainAxis="y" />
      <ScaleButton relativePosition={[1, 0]} constrainAxis="x" />
      <ScaleButton relativePosition={[-1, 0]} constrainAxis="x" />

      <LineHandles />
    </>
  );
};

export default SelectionControls;
